@if (!useSummaryView) {
  @if (!field.hidden) {
    <div animate.enter="fade-in" class="flex flex-row w-full">
      @if (field.browserOpts.inLineWithCaption) {
        <mat-label class="mr-2 mb-4 font-medium">
          {{ field.label | localize }}
          @if (field.mandatoryStart || field.mandatoryEnd) {
            <span> *</span>
          }
        </mat-label>
      }
      <mat-form-field class="w-full">
        @if (!field.browserOpts.inLineWithCaption) {
          <mat-label>
            {{ field.label | localize }}
            @if (field.mandatoryStart || field.mandatoryEnd) {
              <span> *</span>
            }
          </mat-label>
        }
        <mat-date-range-input [formGroup]="field.control" [rangePicker]="picker" (click)="openDatepickerOnClick(picker)"
          [min]="min" [max]="max">
          <input matStartDate formControlName="from" (dateChange)="dateChange($event, 'from')"
            [placeholder]="field.placeholderStart ? (field.placeholderStart | localize) : ('startDatePlaceholder' | transloco)" />
            <input matEndDate formControlName="to" (dateChange)="dateChange($event, 'to')"
              [placeholder]="field.placeholderEnd ? (field.placeholderEnd | localize) : ('endDatePlaceholder' | transloco)" />
            </mat-date-range-input>
            @if (field.hint) {
              <mat-hint>{{ field.hint | localize }}</mat-hint>
            }
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-date-range-picker #picker [startView]="field.remote ? 'multi-year' : 'month'">
            </mat-date-range-picker>
            @if (!field.readonly && startDateControl?.errors) {
              <mat-error>
                @if (startDateControl.hasError('required')) {
                  {{ 'startDateRequired' | transloco }}
                }
                @if (startDateControl.hasError('dateMax')) {
                  {{ 'startDateLessThan' | transloco:{ date: startDateControl.errors.dateMax.dateMax | localizeDate:'dd/MM/yyyy' } }}
                }
                @if (startDateControl.hasError('matDatepickerMax')) {
                  {{ 'startDateLessThan' | transloco:{ date: max | localizeDate:'dd/MM/yyyy' } }}
                }
                @if (startDateControl.hasError('dateMin')) {
                  {{ 'startDateGreaterThan' | transloco:{ date: startDateControl.errors.dateMin.dateMin | localizeDate:'dd/MM/yyyy' } }}
                }
                @if (startDateControl.hasError('matDatepickerMin')) {
                  {{ 'startDateGreaterThan' | transloco:{ date: min | localizeDate:'dd/MM/yyyy' } }}
                }
              </mat-error>
            }
            @if (!field.readonly && endDateControl?.errors) {
              <mat-error>
                @if (endDateControl.hasError('required')) {
                  {{ 'endDateRequired' | transloco }}
                }
                @if (endDateControl.hasError('dateMax')) {
                  {{ 'endDateLessThan' | transloco:{ date: endDateControl.errors.dateMax.dateMax | localizeDate:'dd/MM/yyyy' } }}
                }
                @if (endDateControl.hasError('matDatepickerMax')) {
                  {{ 'endDateLessThan' | transloco:{ date: max | localizeDate:'dd/MM/yyyy' } }}
                }
                @if (endDateControl.hasError('dateMin')) {
                  {{ 'endDateGreaterThan' | transloco:{ date: endDateControl.errors.dateMin.dateMin | localizeDate:'dd/MM/yyyy' } }}
                }
                @if (endDateControl.hasError('matDatepickerMin')) {
                  {{ 'endDateGreaterThan' | transloco:{ date: min | localizeDate:'dd/MM/yyyy' } }}
                }
              </mat-error>
            }
          </mat-form-field>
        </div>
      }
    } @else {
      {{ $safeNavigationMigration(field?.control?.value?.from) | localizeDate: 'dd/MM/yyyy' }}
      {{ field?.control?.value?.to ? ' - ' + (field.control.value.to | localizeDate: 'dd/MM/yyyy') : '' }}
    }


